import { DatePicker } from 'antd';
import s from './index.module.css';
import { useState } from 'react';
import dayjs from 'dayjs';
import { CalendarOutlined } from "@ant-design/icons";
import InputWhite from '@pages/Admin/Mailings/Create/InputWhite';
import CheckBlock from '../../../pages/Journal2/components/common/CheckBlock';
import Button from '../../../UI/Button';
import { useInputNew } from '../../../UI/InputNew/useInputNew';
import { InputSelect } from '../../../UI/InputNew';
//import InputSelect from '../../../pages/Journal2/components/common/InputSelect';
import { settingsAboutChild } from
    '../../../pages/Admin/PlatformSettings2/Ankets/StudentProfileSettings';
import { useAddAlert } from '../../../../hooks/useAddAlert';
import TYPES from '../../TYPES';
import { useDispatch } from 'react-redux';
import { closeModal } from "@store/modalsSlise";

const INPUT_DATE_FORMAT = 'YYYY-MM-DD'
const OUTPUT_DATE_FORMAT = 'DD.MM.YY'

const JournalAddField = ({
    data
}) => {
    const dispatch = useDispatch();
    const [title, setTitle] = useState('');

    const addAlert = useAddAlert();

    const [type, setType] = useState('text');

    const [bindTypes] = useInputNew({
        value: type,
        onChange: (e) => {
            setType(e);
        },
        options: [
            {
                label: 'Текстовый',
                value: 'text'
            },
            {
                label: 'Поле из анкеты учащегося',
                value: 'field'
            }
        ],
    });

    const [childField, setChildField] = useState('isShowPhoneChild');

    const [bindChildField] = useInputNew({
        value: childField,
        onChange: (e) => {
            setChildField(e);
        },
        options: settingsAboutChild.map(el => {
            return {
                label: el.label,
                value: el.name
            }
        }),
    });

    return (<>
        <div className={s.title}>
            Добавить поле
        </div>
        <div className={s.body}>
            <div className={s.block}>
                    <p>Заголовок поля</p>
                    <InputWhite
                        className={s.customDatepicker}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
            </div>
            <div className={s.block}>
                    <p>Тип поля</p>
                <InputSelect
                    newDesign
                    className={s.select}
                    { ...bindTypes }
                />
            </div>
            {
                type === 'field' && <div className={s.block}>
                    <p>Поле из анкеты ученика</p>
                    <InputSelect
                        newDesign
                        className={s.select}
                        { ...bindChildField }
                    />
                </div>
            }
            <Button
                newDesign
                className={s.add}
                action={() => {
                    if (!title) {
                        addAlert({
                            title: 'Введите заголовок поля',
                            type: 'error'
                        })
                        return;
                    }
                    data.add({
                        title,
                        type: type !== 'field' ? type : childField
                    })
                    dispatch(
                        closeModal({
                            type: TYPES.JOURNAL_ADD_FIELD
                        })
                    );
                }}
            >Добавить</Button>
        </div>
    </>)
}

export default JournalAddField;